module.exports = "/images/uk.svg";